import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'contains',
})
export class ContainsPipe implements PipeTransform {
  transform<T>(value: T[] | null | undefined, needle: T): boolean {
    if (!value) {
      return false;
    }

    return value.includes(needle);
  }
}
